import React from 'react';
import styled from '@emotion/styled';
import { StaticQuery, graphql } from 'gatsby';
import { InternalLink, routes } from 'gatsby-theme-apollo';
import { Card, Cards, CardTimeStamp, CardByLine } from './cards';
import { LimitReducer } from '../limit/limiter';
import useLimitedSet from '../../hooks/use-limit';

const PostPreviewCardLink = Card.withComponent(InternalLink);

const PostPreview = styled.div(({ expand }) => ({
  alignAtems: `center`,
  padding: `10px 5px`,
  justifyContent: `center`,
  alignItems: `center`,
  fontSize: `24px`,
  display: `flex`,
  flexDirection: `column`,
  backgroundColor: `rgba(0, 0, 0, 0.9)`,
  height: expand ? `100%` : `auto`,
  width: `100%`
}));

const PostPreviewCards = ({ postPreviews, limit, showInterval = 12, disableShowMore }) => {
  const [postPreviewsToDisplay, currentLimit, increaseLimit] = useLimitedSet({
    initialLimit: limit,
    set: postPreviews,
    interval: showInterval,
    contentType: 'post'
  });

  return (
    <>
      <Cards>
        {postPreviewsToDisplay &&
          postPreviewsToDisplay.length > 0 &&
          postPreviewsToDisplay.map(post => {
            return (
              <PostPreviewCard
                key={post && post.title}
                gameName={post.games && post.games.length !== 0 && post.games[0].name}
                post={post}
                showGameName
              />
            );
          })}
      </Cards>
      {!disableShowMore && (
        <LimitReducer
          limit={currentLimit}
          setSize={postPreviews && postPreviews.length}
          showInterval={showInterval}
          onIncreaseLimit={increaseLimit}
        />
      )}
    </>
  );
};

const PostPreviewCard = ({ gameName, post, showGameName }) => {
  return (
    <StaticQuery
      query={graphql`
        {
          site {
            siteMetadata {
              logoIconURI
            }
          }
        }
      `}
      render={data => {
        if (!post) {
          return <div>Something went wrong loading post :(</div>;
        }

        const postTarget = post.permalink
          ? post.permalink
          : post.page
          ? routes.Page(gameName, post.title)
          : routes.Post(gameName, post.title);

        return (
          <PostPreviewCardLink to={postTarget}>
            <PostPreview show>
              <h2>{post.title}</h2>
              {!post.page && post.subtitle && <h4>{post.subtitle}</h4>}
              {post.author && <CardByLine>by {post.author.name} </CardByLine>}
              <CardTimeStamp createdAt={post.publishedDate || post.createdAt} />
            </PostPreview>
          </PostPreviewCardLink>
        );
      }}
    />
  );
};

export default PostPreviewCards;
